import { useEffect, useRef, useState } from 'react';
import { Button } from '@/components/ui/button';
import { login, saveToken, apiErrorMessage } from '@/lib/api';

export default function LoginScreen({ onAuth }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [shaking, setShaking] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const token = await login(password);
      saveToken(token);
      onAuth();
    } catch (err) {
      setError(apiErrorMessage(err, 'No se pudo conectar. Revisa tu conexión e intenta de nuevo.'));
      setShaking(true);
      setTimeout(() => setShaking(false), 500);
      setPassword('');
      inputRef.current?.focus();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-dvh bg-background flex items-center justify-center p-4">
      <div className={`w-full max-w-xs ${shaking ? 'animate-shake' : ''}`}>
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-primary tracking-tight">Carbi</h1>
          <p className="text-base text-muted-foreground mt-2">Calculadora de carbohidratos por voz</p>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <input
            ref={inputRef}
            type="password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            placeholder="Ingresa la clave"
            className="h-14 w-full rounded-xl border border-input bg-card px-4 text-lg text-center tracking-widest placeholder:tracking-normal placeholder:text-muted-foreground/50 focus:outline-none focus:ring-2 focus:ring-primary/40"
            autoComplete="current-password"
            data-testid="login-password-input"
          />
          {error && (
            <p className="text-base text-destructive text-center font-medium" data-testid="login-error">{error}</p>
          )}
          <Button
            type="submit"
            disabled={!password || loading}
            className="w-full h-14 rounded-xl text-lg font-semibold"
            data-testid="login-submit-button"
          >
            {loading ? 'Entrando…' : 'Entrar'}
          </Button>
        </form>
      </div>
    </div>
  );
}
